/**
 * Copyright (c) 2010-2024 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Injectable } from '@angular/core';
import {
    DateFilterOptions,
    FilterOptions,
    FilterValueType,
    NumberFilterOptions,
    ReportFilterType,
    StringFilterOptions
} from '../state/report.model';
import { DashGisUtil } from '../../shared/dash-gis-util';

@Injectable()
export class ReportFilterService {
    getFilterValue(type: ReportFilterType, field: string, filterValue: FilterValueType): false|FilterOptions {
        if (filterValue) {
            switch (type) {
                case 'string':
                case 'string-exact':
                    if ('value' in filterValue) {
                        return { type, field, value: filterValue.value } as StringFilterOptions;
                    }
                    break;
                case 'number':
                    if ('min' in filterValue || 'max' in filterValue) {
                        return { type, field, ...filterValue } as NumberFilterOptions;
                    }
                    break;
                case 'date':
                    if ('min' in filterValue || 'max' in filterValue) {
                        return { type, field, ...filterValue } as DateFilterOptions;
                    }
                    break;
            }
        }
        return false;
    }

    convertFilterInput(filterType: ReportFilterType, inputValue: any): string|number|Date {
        switch (filterType) {
            case 'string':
            case 'string-exact':
                return typeof inputValue === 'string' ? inputValue : inputValue.toString();
            case 'number':
                return DashGisUtil.parseNumber(inputValue);
            case 'date':
                return new Date(inputValue);
        }
    }

    /*
    getFilterOptions(type: ReportFilterType, field: string, values: FilterValueDictionary) {
        let filter: any = false;
        const testFilter = {};

        if (type && field) {
            switch (type) {
                case 'string':
                case 'string-exact':
                    if (values.value) {
                        filter = { value: values.value };
                    }
                    break;

                case 'number':
                    {
                        let val;
                        if (values.min) {
                            val = typeof values.min === 'number' ? values.min : parseFloat(values.min);
                            if (val) {
                                testFilter['min'] = val;
                            }
                        }

                        if (values.max) {
                            val = typeof values.max === 'number' ? values.max : parseFloat(values.max);
                            if (val) {
                                testFilter['max'] = val;
                            }
                        }

                        filter = Object.keys(testFilter).length > 0 ? testFilter : filter;
                    }
                    break;

                case 'date':
                    {
                        let val;
                        if (values.min) {
                            val = values.min;
                            if (typeof val === 'string' || moment(val).isValid()) {
                                testFilter['min'] = val;
                            }
                        }

                        if (values.max) {
                            val = values.max;
                            if (typeof val === 'string' || moment(val).isValid()) {
                                testFilter['max'] = val;
                            }
                        }

                        filter = Object.keys(testFilter).length > 0 ? testFilter : filter;
                    }
                    break;
            }
        }

        if (filter) {
            filter = { ...filter, type, field };
        }
        return filter;
    }
     */
}
